<template>
  <FormModal
    :name="name"
    header="Join collection"
    description="Why do you want to join?"
  >
    <FormModalBody
      :is-button-loading="form.processing"
      @submit="sendRequestInvite"
    >
      <FormInput
        v-model="form.message"
        as="textarea"
        placeholder="Tell us more..."
        :is-error="errors.message"
        errors="Can't be blank. Is too short (minimum is 5 characters)."
        test_id="request-invite-message"
        rows="3"
      />
    </FormModalBody>
  </FormModal>
</template>

<script setup>
import FormModalBody from '@/shared/components/modals/FormModal/FormModalBody.vue'
import FormInput from '@/shared/components/forms/FormInput.vue'
import FormModal from '@/shared/components/modals/FormModal/FormModal.vue'
import { useForm } from '@inertiajs/vue3'
import { ref, watch } from 'vue'
import { useModals } from '@/shared/composables/useModals.js'
import { notify } from '@kyvg/vue3-notification'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  collectionId: {
    type: Number,
    required: true,
  },
})

const { closeModal } = useModals()

const form = useForm({
  message: '',
})
const errors = ref({
  message: false,
})

watch(
  () => form.message,
  () => {
    if (errors.value.message) errors.value.message = false
  },
)

const sendRequestInvite = () => {
  if (form.message.length < 5) {
    errors.value.message = true
    return
  }

  form.post(`/collections/${props.collectionId}/members`, {
    preserveScroll: true,
    onSuccess: () => {
      closeModal(props.name)
      notify({
        type: 'success',
        text: `You've successfully joined the collection!`,
      })
    },
  })
}
</script>
